module.exports = __webpack_public_path__ + "img/clothes_crocodile_bottom@2x.93329a36.png";